'use strict';

const angular = require('angular');

module.exports = angular.module('spinnaker.cluster.kubernetes', [
  require('./configure/CommandBuilder.js').name,
]);



// WEBPACK FOOTER //
// ./app/scripts/modules/kubernetes/src/cluster/cluster.kubernetes.module.js